// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"8523":"8aa22271","9923":"8e095c31"}[chunkId] || chunkId) + "." + {"1228":"3b5f70f7421fc790","2421":"aacc94b0bba8f85b","2609":"5f5376fc22371dc4","3054":"ac617eceb571ea45","3595":"340445faf70c4148","6253":"be5d1db53c47e4b0","8523":"73dcf5d38d9f665e","9923":"512e0f83378eedca"}[chunkId] + ".js";
};